<template>
  <Toast position="top-right" class="fixed-top" style="z-index: 9999" />
  <div>
    <RouterView />
  </div>
</template>

<script setup>
  import Toast from "primevue/toast";
  import { onMounted, ref } from "vue";
  import { RouterView } from "vue-router";

  const classesToAdd = ['scroll-smooth'];
  const htmlTag = ref(null);
  onMounted(() => {
    getHtml();
    addClassToHtml();
  });

  function getHtml() {
    htmlTag.value = document.querySelector('html') ?? null;
  }

  function addClassToHtml() {
    if (!htmlTag.value) {
      return false;
    }

    for (let className of classesToAdd) {
      if (!htmlTag.value.classList.contains(className)) {
        htmlTag.value.classList.add(className);
      }
    }
  }
</script>
